import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedEventCard = ({ event, to }) => {
  const { title, date, time, city, venue, imageUrl } = event;
  const href = to || `/events/${event.slug || event.id || ''}`;

  return (
    <Link
      to={href}
      className="group flex-shrink-0 w-[220px] sm:w-[240px] bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow overflow-hidden"
    >
      {/* Image */}
      <div className="relative h-[130px] overflow-hidden bg-gray-100">
        <img
          src={imageUrl}
          alt=""
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        <h3 className="font-semibold text-gray-900 text-[13px] leading-snug line-clamp-2 mb-1.5">
          {title}
        </h3>

        <div className="flex items-center gap-1 text-[11px] text-gray-500 mb-1">
          <svg className="h-3 w-3 flex-shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
          </svg>
          <span>{date}{time ? ` | ${time}` : ''}</span>
        </div>

        <div className="flex items-center gap-1 text-[11px] text-gray-500 mb-2.5">
          <svg className="h-3 w-3 flex-shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
          </svg>
          <span className="line-clamp-1">{city}{venue ? ` | ${venue}` : ''}</span>
        </div>

        <span className="w-full flex items-center justify-center gap-1 rounded-md border border-emerald-600 px-3 py-1.5 text-[11px] font-medium text-emerald-700 group-hover:bg-emerald-50 transition-colors">
          Get Details
          <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </span>
      </div>
    </Link>
  );
};

export default FeaturedEventCard;
